import clsx from "clsx";
import { ExclamationCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import React, { forwardRef } from "react";

const Input = forwardRef(function Input(
  { startIcon, endIcon, onChange, register, error, onReset, ...others },
  ref
) {
  return (
    <div>
      <div className="relative">
        <input
          ref={ref}
          className={clsx(
            "border-none focus:outline-inputFocused outline-secondaryBorder disabled:bg-secondaryHover placeholder-inputPlaceholder text-inputText outline outline-1 focus:outline-2 w-full px-3 py-2 rounded-lg shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)] text-base font-normal disabled:cursor-not-allowed",
            {
              "focus:!outline-inputIconError !outline-inputBorderError pr-10":
                error,
              "pl-10": startIcon,
              "pr-10": endIcon,
            }
          )}
          onChange={onChange}
          {...others}
          {...(register ? register(others?.name, { onChange }) : {})}
        />

        {startIcon && (
          <div className="absolute left-2 top-1/2 -translate-y-1/2">
            {startIcon}
          </div>
        )}

        {endIcon && (
          <div className="absolute right-2 top-1/2 -translate-y-1/2">
            {endIcon}
          </div>
        )}

        {error && (
          <ExclamationCircleIcon className="size-6 text-inputIconError absolute right-2 top-1/2 -translate-y-1/2" />
        )}

        {typeof onReset === "function" && (
          <button
            type="button"
            onClick={onReset}
            className="absolute right-2 top-1/2 -translate-y-1/2"
          >
            <XMarkIcon className="size-6 text-gray-400 hover:text-gray-500" />
          </button>
        )}
      </div>

      {error && (
        <div className="mt-2">
          <p className="m-0 p-0 text-inputTextError text-sm font-normal leading-tight">
            {error}
          </p>
        </div>
      )}
    </div>
  );
});

export default Input;
